module.exports = __webpack_public_path__ + "static/img_1412-67e737dab656877f5897455dfa0120bf.webp";